import api from "../../Services/api";

export const createForm = async (formJsonSchema) => {
  try {
    const response = await api.post("/forms/create", formJsonSchema);
    return response.data;
  } catch (error) {
    console.error("Error sending form schema:", error);
    throw error;
  }
};

export const fetchFormsSets = async () => {
  try {
    const response = await api.get("/forms/formset/all", {
      data: {},
    });
    return response.data.formSets;
  } catch (error) {
    console.error("Error fetching forms:", error);
    throw error;
  }
};
